



























import { Component, Prop, Vue } from 'vue-property-decorator'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { BasicProductV2 as BasicProduct } from '@master/model/kyc-form/product/BasicProductV2'
import { IRiskRatingService } from '@master/services/IRiskRatingService'
import { inject } from 'inversify-props'

@Component({
  components: {
    AppForm
  }
})
export default class TheRcmdProductTemplate<T> extends Vue {
  @inject()
  protected riskRatingService: IRiskRatingService

  @Prop() firstFormStructure: FormStructure<BasicProduct>
  @Prop() inputProductModal: BasicProduct
  @Prop() subsectionHeader: string
  @Prop() subProductFormStructure: Function | FormStructure<T>
  @Prop() subProductList: FormStructure<T>
  @Prop() additionalButtonEnable?: FormStructure<T>

 private targetProductModal: BasicProduct = null

 addSubProductOnClick () {
   this.$emit('addSubProduct')
 }

 deleteSubProductFund (index) {
   this.$emit('deleteSubProduct', { index: index })
 }

 mounted () {
   this.targetProductModal = new BasicProduct(this.riskRatingService)
   Object.assign(this.targetProductModal, this.inputProductModal)
 }
}

